export interface SipStepUpInput {
  amount: string; // Monthly SIP amount (string, may have commas)
  expectedReturn: number; // Annual return % (e.g. 12 for 12%)
  years: number; // Investment duration in years
  increaseBy: number; // Annual SIP increment % (step-up rate)
}

export interface SipStepUpResult {
  totalInvestment: number; // Sum of all SIPs (formatted)
  totalCorpus: number; // Final corpus (formatted)
  totalReturns: number; // Corpus - invested (formatted)
  cagr: number; // CAGR % (unformatted)
}

export const calculateSipStepUp = ({ amount, expectedReturn, years, increaseBy }: SipStepUpInput): SipStepUpResult => {
  const investAmountNum = Number(amount.replace(/,/g, ""));
  const returnRate = expectedReturn / 12 / 100;
  const totalMonths = years * 12;

  let totalInvestment = 0;
  let currentBalance = 0;
  let totalProfit = 0;
  let currentInvestment = investAmountNum;
  let increasAmt = 0;

  for (let month = 1; month <= totalMonths; month++) {
    const profit = currentBalance * returnRate;
    totalProfit += profit;

    if (month > 1 && (month - 1) % 12 === 0) {
      currentInvestment += increasAmt;
    }

    totalInvestment += currentInvestment;
    currentBalance = totalInvestment + totalProfit;

    increasAmt = (currentInvestment * increaseBy) / 100;
  }

  const totalReturns = currentBalance - totalInvestment;
  const cagr = totalInvestment > 0 ? (Math.pow(currentBalance / totalInvestment, 1 / years) - 1) * 100 : 0;

  return {
    totalInvestment: Number(totalInvestment.toFixed(0)),
    totalCorpus: Number(currentBalance.toFixed(0)),
    totalReturns: Number(totalReturns.toFixed(0)),
    cagr,
  };
};
